import React from 'react';
import { Brush, CartesianGrid, XAxis, YAxis } from 'recharts';
import { arrayOf, bool, color, expression, number, object, oneOf, oneOfType, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { ChartAxisType, ChartLayout, ChartXAxisOrientation, ChartYAxisOrientation } from '../base-chart/base-chart-constants.js';
import { BaseChart } from '../base-chart/base-chart.js';
const intervalOptions = ['preserveEnd', 'preserveStart', 'preserveStartEnd'];
const axisShape = {
    angle: number,
    dataKey: string,
    height: number,
    hide: bool,
    interval: oneOfType([
        oneOf(intervalOptions),
        number,
    ]),
    label: expression,
    minTickGap: number,
    tickMargin: number,
    type: oneOf(enumValues(ChartAxisType)),
    width: number,
};
class AxisChart extends BaseChart {
    renderBrush() {
        const { brush, showBrush } = this.props;
        if (!showBrush) {
            return null;
        }
        return (React.createElement(Brush, { ...brush }));
    }
    renderCartesianGrid() {
        const { showCartesianGrid } = this.props;
        if (!showCartesianGrid) {
            return null;
        }
        return (React.createElement(CartesianGrid, null));
    }
    renderXAxis() {
        const { xAxis } = this.props;
        const label = xAxis?.label ?? '';
        return (React.createElement(XAxis, { ...xAxis, label: {
                position: 'insideBottom',
                value: MessageService.translate(label),
            } }));
    }
    renderYAxis() {
        const { yAxis } = this.props;
        const value = MessageService.translate(yAxis?.label ?? '');
        return (React.createElement(YAxis, { ...yAxis, label: {
                angle: -90,
                position: 'insideLeft',
                value,
            } }));
    }
    render() {
        return super.render();
    }
}
AxisChart.propTypes = {
    ...BaseChart.propTypes,
    brush: shape({
        className: string,
        dataKey: string,
        endIndex: number,
        gap: number,
        startIndex: number,
        stroke: color,
        x: number,
        y: number,
    }).group('brush'),
    data: arrayOf(object).notEnumerable(),
    layout: oneOf(enumValues(ChartLayout)).group('cartesian area'),
    showBrush: bool.group('brush'),
    showCartesianGrid: bool.group('cartesian area'),
    syncId: string,
    xAxis: shape({ ...axisShape, orientation: oneOf(enumValues(ChartXAxisOrientation)) }).group('cartesian area'),
    yAxis: shape({ ...axisShape, orientation: oneOf(enumValues(ChartYAxisOrientation)) }).group('cartesian area'),
};
AxisChart.defaultProps = {
    ...BaseChart.defaultProps,
    layout: ChartLayout.HORIZONTAL,
    showBrush: false,
    showCartesianGrid: true,
};
export { AxisChart, };
//# sourceMappingURL=axis-chart.js.map